import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for managing client documents
 */
const create = (handleUnauthorized) => { 

    const api = BaseApi.create({unAuthorizedFunction: handleUnauthorized});

    const uploadDocument = (document, config) => api.upload(ApiPaths.UPLOAD_DOCUMENT, document, config);
    const downloadDocument = (documentId) => api.getBlob(ApiPaths.DOCUMENT(documentId));
    const getDocumentList = (taxYear, pageIndex) => api.get(ApiPaths.LIST_DOCUMENTS(taxYear, pageIndex));
    const deleteDocument = (documentId) => api.deleteRequest(ApiPaths.DOCUMENT(documentId));
    const updateDocumentMetadata = (documentId, metadata) => api.put(ApiPaths.DOCUMENT(documentId), metadata);

    // Return back a collection of functions
    return { uploadDocument, downloadDocument, getDocumentList, deleteDocument, updateDocumentMetadata }
}

// let's return back our create method as the default.
export default {
    create
}
